/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import ListHeader from "components/Headers/ListHeader";
import axiosConfig from "consts/axiosConfig";
import { Card, CardHeader, Container, Row, Spinner } from "reactstrap";

const { SearchBar } = Search;

export default function ManageNetwork(props) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const pagination = paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ onSizePerPageChange }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    ),
  });

  const getItems = () => {
    setLoading(true);
    axiosConfig
      .get("network/requests/user")
      .then((res) => {
        setLoading(false);
        setData(res.data.result.follower);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const acceptFollow = (user_id) => {
    setLoading(true);
    axiosConfig
      .get("network/accept_request/user/" + user_id)
      .then((res) => {
        getItems();
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const rejectFollow = (user_id) => {
    setLoading(true);
    axiosConfig
      .get("network/reject_request/user/" + user_id)
      .then((res) => {
        getItems();
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getItems();
  }, []);
  return (
    <>
      <ListHeader name="Connection Requests" parentName="Dashboard" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <h3 className="mb-0">Connection Requests</h3>
              </CardHeader>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "fullname",
                    text: "From",
                    sort: true,
                    formatter: (cell, row) => {
                      return (
                        <span>
                          {row.fullname ? (
                            <a href={`/user/u/${row.id}`} target="_blank">
                              {row.fullname}
                            </a>
                          ) : (
                            <a href={`/user/o/${row.id}`} target="_blank">
                              {row.name}
                            </a>
                          )}
                        </span>
                      );
                    },
                  },
                  {
                    dataField: "city",
                    text: " City",
                    sort: true,
                  },
                  {
                    dataField: "specialty",
                    text: " Specialty",
                    sort: true,
                  },
                  {
                    dataField: "state",
                    text: " State",
                    sort: true,
                  },
                  {
                    dataField: "name",
                    text: "Actions",
                    editable: true,
                    sort: false,
                    formatter: (cell, row) => {
                      return (
                        <>
                          <a
                            className="btn btn-primary btn-sm"
                            href={
                              row.fullname
                                ? `/user/u/${row.id}`
                                : `/user/o/${row.id}`
                            }
                          >
                            Show Profile
                          </a>
                          <a
                            className="btn btn-success btn-sm"
                            onClick={() => acceptFollow(row.id)}
                          >
                            Accept
                          </a>
                          <a
                            className="btn btn-danger btn-sm"
                            onClick={() => rejectFollow(row.id)}
                          >
                            Reject
                          </a>
                        </>
                      );
                    },
                  },
                ]}
                search
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <div
                      id="datatable-basic_filter"
                      className="dataTables_filter px-4 pb-1"
                    >
                      <label>
                        Search:
                        <SearchBar
                          className="form-control-sm"
                          placeholder=""
                          {...props.searchProps}
                        />
                      </label>
                    </div>
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={false}
                      hover={true}
                      noDataIndication={
                        loading ? (
                          <Spinner color="info" size="xl" />
                        ) : (
                          <p>No Connection Requests yet!</p>
                        )
                      }
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
